import React, { useContext, useState, useRef } from 'react';
import { Icons, Menu, MenuItem } from '@nextiva/next-ui-components';

import { FeatureContext } from 'components/AccessResolvers/featureContext';
import {
  StyledMenuIconButton,
  StyledMenuIcon,
} from 'components/MenuIconButton';

const linksConst = {
  EDIT_LOCATION: 'editLocation',
  VOICE_SETTINGS: 'voiceSettings',
  CALL_CENTER: 'callCenter',
  DELETE_LOCATION: 'deleteLocation',
};

const anchorOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};

const transformOrigin = {
  vertical: 'top',
};

export const LocationActions = React.memo(
  ({
    location,
    editAction,
    centerAction,
    deleteAction,
    voiceAction,
    isVoiceAccount,
    callCenterLicense,
  }) => {
    const {
      featureState: { isClusterIdInBWPatching, voiceActions },
    } = useContext(FeatureContext);
    const menuButtonRef = useRef(null);

    const [actionsOpen, setActionsOpen] = useState(false);

    // If the cluster from which site been serverd is under BW patching then remove options
    // related to voice settings/setup and don't allow edit for voice enabled location.
    const getOptionsForBWCluster = (options) => {
      if (isClusterIdInBWPatching)
        return options.filter(
          (option) =>
            !(
              option.value === linksConst.VOICE_SETTINGS ||
              option.value === linksConst.VOICE_SETUP ||
              (location.voiceEnabled &&
                option.value === linksConst.EDIT_LOCATION)
            ),
        );

      return options;
    };

    const optionsList = (() => {
      const options = [
        {
          label: 'Edit Location',
          value: linksConst.EDIT_LOCATION,
          onClick: () => editAction(location),
        },
        {
          label: 'Delete Location',
          value: linksConst.DELETE_LOCATION,
          onClick: () => deleteAction(location),
        },
      ];

      if (voiceActions) {
        options.unshift({
          label: 'Voice Settings',
          value: linksConst.VOICE_SETTINGS,
          onClick: () => voiceAction(location),
        });
      }

      if (
        isVoiceAccount &&
        callCenterLicense &&
        location.voiceEnabled &&
        !isClusterIdInBWPatching
      ) {
        options.unshift({
          label: 'Call Center',
          value: linksConst.CALL_CENTER,
          onClick: () => centerAction(location),
        });
      }

      return getOptionsForBWCluster(options);
    })();

    return (
      <>
        <StyledMenuIconButton
          onClick={() => setActionsOpen(true)}
          data-testid="PlatformAdminUI-LocationActions-MenuIconButton"
          aria-label="Menu Icon Button"
          ref={menuButtonRef}
        >
          <StyledMenuIcon icon={Icons.menu} />
        </StyledMenuIconButton>
        <Menu
          open={actionsOpen}
          onClose={() => setActionsOpen(false)}
          anchorEl={menuButtonRef.current}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
          disableAutoFocusItem
        >
          {optionsList.map((option) => (
            <MenuItem
              onClick={option.onClick}
              data-testid={`PlatformAdminUI-LicensesRow-${option.value}`}
            >
              <div>{option.label}</div>
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  },
);
